/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React from "react";
import * as _ from "lodash";
import isEqual from "lodash/isEqual";
import InterfaceTable from "./InterfaceTable";

const isArrayEqual = function (x, y) {
  return _(x).differenceWith(y, isEqual).isEmpty();
};

function areEqual(prevProps, nextProps) {
  if (
    !isArrayEqual(prevProps.interfaceData, nextProps.interfaceData) ||
    !isEqual(prevProps.fromTreeView, nextProps.fromTreeView) ||
    !isEqual(prevProps.fromGroupsView, nextProps.fromGroupsView) ||
    !isEqual(prevProps.openAlarmViewForInterface, nextProps.openAlarmViewForInterface) ||
    !isArrayEqual(prevProps.groupData, nextProps.groupData) ||
    !isEqual(prevProps.isTreeOpen, nextProps.isTreeOpen) ||
    !isEqual(prevProps.openDetailedViewInterface, nextProps.openDetailedViewInterface) ||
    !isEqual(prevProps.openDetailInterfaceFromTreeView, nextProps.openDetailInterfaceFromTreeView) ||
    !isEqual(prevProps.showInterfaceDetail, nextProps.showInterfaceDetail)
  ) {
    return false;
  }
  return true;
}

const InterfaceTableMemoized = React.memo((props) => {
  return (
    <InterfaceTable
      interfaceData={props.interfaceData}
      fromTreeView={props.fromTreeView}
      fromGroupsView={props.groupId !== null ? props.fromGroupsView : false}
      openAlarmViewForInterface={props.openAlarmViewForInterface}
      groupData={props.groupData}
      isTreeOpen={props.openTree}
      openDetailedViewInterface={props.openDetailedViewInterface}
      openDetailInterfaceFromTreeView={props.openDetailInterfaceFromTreeView}
      showInterfaceDetail={props.showInterfaceDetail}
      {...props}
    />
  );
}, areEqual);

export default InterfaceTableMemoized;
